import React from "react";
import { HouseFill, FileEarmarkFill } from "react-bootstrap-icons";
import { FaDollarSign } from "react-icons/fa6";
import { FaChartBar } from "react-icons/fa";

import { PATHS } from "../../../routes/paths";

export const POWER_BI_URL =
  "https://app.powerbi.com/groups/f0da8494-4443-4a34-89d5-01b8d71e5a8e/reports/e7d77d81-29ff-4d43-b70f-d2a7f16b7902?ctid=6f875e12-0f6f-4fff-bdbe-d552254e7653&pbi_source=linkShare&bookmarkGuid=fe974421-bee4-4067-81e9-788ad7b06883";

export const ROLE = {
  ADMIN_TI: 1,
  ADMIN: 2,
  ANALISTA: 3,
  SINDICATO: 4,
};

const commonMenuItems = [
  { key: "home", label: "Início", icon: <HouseFill />, path: PATHS.HOME },
];

const docItemsAnaliseOnly = {
  key: "documentacao",
  label: "Documentação",
  icon: <FileEarmarkFill />,
  submenu: [{ key: "analise", label: "Análise", path: PATHS.DOC_ANALYSIS }],
};

const docItemsEnvioOnly = {
  key: "documentacao",
  label: "Documentação",
  icon: <FileEarmarkFill />,
  submenu: [{ key: "envio", label: "Envio", path: PATHS.DOC_SHIPPING }],
};

// Administradores (TI e comum) não veem "Envio comp." — esse fluxo é
// exclusivo de Sindicato.
const adminFinanceItems = {
  key: "financeiro",
  label: "Financeiro",
  icon: <FaDollarSign />,
  submenu: [
    { key: "extrato", label: "Extrato", path: PATHS.DOC_EXTRACT },
    {
      key: "conf_comp",
      label: "Conferência comp.",
      path: PATHS.EXTRACT_PAYMENT_TABLE,
    },
    { key: "pagamento", label: "Pagamento", path: PATHS.PAYMENT_ROOT },
  ],
};

const relatoriosPowerBI = {
  key: "relatorios",
  label: "Relatórios",
  icon: <FaChartBar />,
  submenu: [
    {
      key: "programa_atual",
      label: "Programa atual",
      path: PATHS.BI_REPORT_VIEW.replace(":ano", "2026"),
    },
    {
      key: "edicoes_anteriores",
      label: "Edições anteriores",
      path: PATHS.BI_REPORT_VIEW.replace(":ano", "2025"),
    },
  ],
};

export const MENU_BY_ROLE = {
  [ROLE.ADMIN_TI]: [docItemsAnaliseOnly, adminFinanceItems, relatoriosPowerBI],
  [ROLE.ADMIN]: [docItemsAnaliseOnly, adminFinanceItems, relatoriosPowerBI],

  [ROLE.ANALISTA]: [
    docItemsAnaliseOnly,
    {
      key: "financeiro",
      label: "Financeiro",
      icon: <FaDollarSign />,
      submenu: [
        { key: "extrato", label: "Extrato", path: PATHS.DOC_EXTRACT },
        {
          key: "conf_comp",
          label: "Conferência comp.",
          path: PATHS.EXTRACT_PAYMENT_TABLE,
        },
        { key: "pagamento", label: "Pagamento", path: PATHS.PAYMENT_ROOT },
      ],
    },
    relatoriosPowerBI,
  ],

  [ROLE.SINDICATO]: [
    docItemsEnvioOnly,
    {
      key: "financeiro",
      label: "Financeiro",
      icon: <FaDollarSign />,
      submenu: [
        { key: "extrato", label: "Extrato", path: PATHS.EXTRACT_SINDICATO },
        {
          key: "envio_comp",
          label: "Envio comp.",
          path: PATHS.COMPROVANTES_SINDICATO,
        },
        // { key: "pagamento", label: "Pagamento", path: PATHS.PAYMENT_LISTA },
      ],
    },
  ],
};

export function getMenuItemsByRole(roleId) {
  const roleItems = MENU_BY_ROLE[roleId] || [];
  return [...commonMenuItems, ...roleItems];
} 